/** Explicit accounting reference beside the original document evidence. */
export default function HistoryExternalNumber({ value }: { value?: string | null }) {
  return value ? (
    <span className="mt-0.5 block break-words text-xs text-slate-600 [overflow-wrap:anywhere]" title={`ER-Nummer ${value}`}>
      ER {value}
    </span>
  ) : null;
}
